module.exports = __webpack_public_path__ + "img/69274c4.jpg";